// src/layouts/MainLayout.js
import React, { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import TopBar from "./TopBar";
import SideDrawer from "./SideDrawer";

const MainLayout = ({ children }) => {
  const [isDrawerCollapsed, setIsDrawerCollapsed] = useState(false);

  const handleToggleDrawer = () => {
    setIsDrawerCollapsed(!isDrawerCollapsed);
  };

  // Ancho del drawer según su estado
  const drawerWidth = isDrawerCollapsed ? 64 : 300;

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#ffffff",
        height: '100vh'
      }}
    >
      <CssBaseline />

      {/* Drawer lateral permanente */}
      <SideDrawer
        isCollapsed={isDrawerCollapsed}
        onToggleDrawer={handleToggleDrawer}
      />

      {/* AppBar fijo en la parte superior */}
      <TopBar drawerWidth={drawerWidth} />

      {/* Contenedor del contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: "64px", // espacio para el AppBar
          width: `calc(100% - ${drawerWidth}px)`,
          px: 4,
          transition: 'width 0.3s ease', // Transición suave al cambiar el ancho
          overflow: 'auto', // Para manejar el scroll si es necesario
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
